import scrollIntoView from 'scroll-into-view';
import isPlainObject from 'lodash/isPlainObject';

const getTopInvalidItem = (items, sort) => {
  const itemsToSort = Object.keys(items).filter(i => sort.includes(i)) || [];
  const sortedItems = itemsToSort.sort((a, b) => (sort.indexOf(a) > sort.indexOf(b) ? 1 : -1));

  return sortedItems && sortedItems.length !== 0 && sortedItems[0];
};

const getInvalidItem = (items, sortOrder) =>
  items && isPlainObject(items) && getTopInvalidItem(items, sortOrder);

const scrollToItem = item =>
  setTimeout(scrollIntoView(document.getElementById(item), { time: 500 }), 500);

const scrollToClass = className => {
  const element = document.getElementsByClassName(className) || [];
  return setTimeout(scrollIntoView(element[0], { time: 500 }), 500);
};

export { getInvalidItem, scrollToItem, scrollToClass };
